export default {
  document: {
    title: 'INDYCAR Fantasy Challenge'
  },
  sso: {
    url: '/#/fake-sso',
    authority: 'https://indycar.b2clogin.com/indycar.onmicrosoft.com/',
    tenantId: '5954d40b-58cd-4e9e-888f-d353b3a8f4c7',
    clientId: '9abcd97f-09d4-40e1-b194-4e9749c7e878',
    clientAppName: 'FantasyRacingApp',
    redirectUri: 'https://indycar.onmicrosoft.com/FantasyRacingApp',
    scope: 'https://indycar.onmicrosoft.com/api/FantasyRacingApp.Read',
    userFlows: {
      B2C_1_PassReset:
        'https://indycar.b2clogin.com/indycar.onmicrosoft.com/B2C_1_PassReset',
      B2C_1_SignUpIn:
        'https://indycar.b2clogin.com/indycar.onmicrosoft.com/B2C_1_SignUpIn'
    },
    login: '/Account/SignIn',
    logout: '/Account/SignOut',
    forgotPassword: '/Account/ForgotPassword'
  },
  api: {
    // root: "https://localhost:44320/api" // If running ASP.NET web API locally
    root: process.env.VUE_APP_API
  },
  supportEmail: 'support@brickyard.com',
  storageKey: 'ims-store-v202001',
  usCountryCode: 840, // Default profile country code
  maxLapSpeed: 235, // Fastest recommended lap
  maxRaceAgeToShow: 6, // number of months back
  serviceProblemTimeout: 29000, // number of ms to wait before reporting a potential problem
  refreshLeagueDetails: false, // Auto Reload the Live leagueDetails /#/league/1 (L3)
  refreshLeagueRace: false, // Auto Reload Live League Race (L4)
  refreshMS: 60000, // number of milliseconds
  status: {
    COMPLETE: 'Complete',
    IN_PROGRESS: 'In-Progress',
    PRE_EVENT: 'Pre-Event',
    PRE_RACE: 'Pre-Race',
    SUSPENDED: 'Suspended',
    CANCELED: 'Canceled'
  }
};
